<template>
    <div>
        <Loading :isLoading="isLoading" />
        <CRow style="height:100% !important" >
            <CCol col="12" xl="12" style="height:100% !important">
                <transition name="slide">
                    <CCard style="height:100% !important">
                        <CCardBody height="100%">
                            <CRow>
                                <div class="col-sm-5 offset-sm-2">
                                    <CSelect 
                                        :placeholder="$t('categories.placeholder')" 
                                        :label="$t('categories.title')" 
                                        :options="categories"
                                        :value.sync="field.category_id"
                                        :plain="true"
                                    ></CSelect>
                                </div>
                                <div class="col-sm-1">
                                    <CButton color="warning" @click="onClean" class="m-2">
                                        <CIcon :content="deleteIcon" /> {{ $t('button.clean') }}
                                    </CButton>
                                </div>
                                <div class="col-sm-1">
                                    <CButton color="success" @click="onFilter" class="m-2">
                                        <CIcon :content="btnSearch" /> {{ $t('button.filter') }}
                                    </CButton>
                                </div>
                                <div class="col-sm-1 pt-2 ml-2">
                                    <CIcon :content="iconDiamond" size="2xl"/>
                                    <label class="ml-2">{{getRandomInt}}</label>
                                </div>
                            </CRow>
                            <div v-infinite-scroll="loadMore" 
                                infinite-scroll-disabled="busy" 
                                infinite-scroll-distance="13"
                            >
                                <CRow v-for="item of data" :key="item.id">
                                    <div class="col-sm-6 offset-sm-3">
                                        <ProviderItem 
                                            :item="item" 
                                            @onShowItem="onShowItem" 
                                        />
                                    </div>
                                </CRow>
                            </div>
                        </CCardBody>  
                    </CCard>
                </transition>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import axios from 'axios'
import catalog from '../../hooks/catalogs';
import ProviderItem from "./components/Item.vue";
import Loading from "../../components/Loading.vue";
import { cilPlus, cilSearch, cilTrash, cilDiamond } from '@coreui/icons';

export default {
    name: 'Provider',
    mixins: [catalog],
    components: {
        Loading,
        ProviderItem,
    },
    data() {
        return {
            page: 1,
            item: {},
            data: [],
            states: [],
            types: [
                {
                    value: "1",
                    label: "Cargas premium",
                }
            ],
            busy: false,
            lastPage: 1,
            field: {
                category_id: '',
            },
            isLoading: true,
            addIcon: cilPlus,
            categories: [],
            showDetail: false,
            btnSearch: cilSearch,
            deleteIcon: cilTrash,
            iconDiamond: cilDiamond,
        }
    },
    computed: {
        getRandomInt() {
            var min = 2000; 
            var max = 3000;
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1) + min);
        },
    },
    methods: {
        onShowItem(item) {  
            this.item = item;
            this.showDetail = true;
        },
        onShowCloseItem() {  
            this.item = {};
            this.showDetail = false;
        },
        onClean() {  
            this.field = {
                category_id: '',
            };

            this.page = 1;
            this.data = [];
            this.lastPage = 1;
            this.isLoading = true;
            this.onGetRecords();
        },
        onFilter() {  
            this.page = 1;
            this.data = [];
            this.lastPage = 1;
            this.isLoading = true;
            this.onGetRecords();
        },
        loadMore() {  
            let self = this;

            if (self.lastPage > self.page) {
                self.page++;
                self.busy = true;
                self.isLoading = true;
                self.onGetRecords();
            }
        },
        onGetRecords() {  
            let self = this;
            const token = localStorage.getItem('token', null);

            var url = `ads?page=${this.page}&category_id=${this.field.category_id}`;

            axios.get(url, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    }
                })
                .then(response => {
                    self.lastPage = response.data.last_page;
                    self.data.push(...response.data.data);
                    self.busy = false;
                    self.isLoading = false;
                }).catch(error => {
                    if (error.response.status === 401) {
                        self.$router.push({ path: '/login' });
                    } else {
                        self.$toast.error(error.response.data.message);
                    }
                });
        },
    },
    mounted() {
        let self = this;

        axios.get(`categories`)
            .then(response => {
                response.data.forEach(function(record){
                    self.categories.push({
                        value: record.id,
                        label: record.name,
                    });
                });
            }).catch(error => {
                if (error.response.status === 401) {
                    self.$router.push({ path: '/login' });
                } else {
                    self.$toast.error(error.response.data.message);
                }
            });

        self.onGetRecords();
    }
}
</script>

<style>
    .label {
        color: white;
        font-size: 20px;
    }
    .btn-detail {
        height: 50px; 
        padding: 10px;
        font-size: 20px;
        cursor: pointer;
        font-weight: bold;
        text-align: center; 
        border-radius: 25px; 
        background-color: grey; 
        color: white !important; 
        border: 2px solid white; 
    }
</style>
